const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://tnjvdswykmzvxcwfoycj.supabase.co';

interface NavigatorWithConnection extends Navigator {
  connection?: { effectiveType?: string; downlink?: number; rtt?: number };
}

export const reportError = (page: string, error: unknown) => {
  try {
    const message =
      error instanceof Error ? error.message : String(error);
    
    const lowerMessage = message.toLowerCase();
    
    // Classify error type based on message content (not instanceof)
    // because callers often wrap errors in new Error(), losing the original type
    const isAbortError = error instanceof DOMException && error.name === "AbortError";
    const isNetworkMessage = 
      lowerMessage.includes("failed to fetch") ||
      lowerMessage.includes("load failed") ||
      lowerMessage.includes("network request failed") ||
      lowerMessage.includes("networkerror");
    const isTimeoutMessage =
      lowerMessage.includes("timed out") || 
      lowerMessage.includes("timeout") ||
      lowerMessage.includes("aborted");
    
    const errorType = isAbortError
      ? "timeout"
      : isNetworkMessage
        ? "network"
        : isTimeoutMessage
          ? "timeout"
          : "unknown";

    const nav = navigator as NavigatorWithConnection;

    const payload = {
      page,
      error_message: message,
      error_type: errorType,
      user_agent: navigator.userAgent,
      connection_type: nav.connection?.effectiveType || null,
      referrer: document.referrer || null,
      screen_width: window.screen?.width || null,
      screen_height: window.screen?.height || null,
    };

    const url = `${SUPABASE_URL}/functions/v1/log-client-error`;
    const body = JSON.stringify(payload);

    // Use sendBeacon as primary for WebViews (survives page pauses/unloads),
    // then fall back to fetch.
    const beaconSent =
      typeof navigator.sendBeacon === 'function' &&
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));

    if (!beaconSent) {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
      }).catch(() => {});
    }
  } catch {
    // never throw from error reporter
  }
};
